import { ErrorStateMatcher } from '@angular/material/core';
import { Observable } from 'rxjs';
import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export class ObservableErrorStateMatcher extends ErrorStateMatcher {
  private error = false;

  constructor(private readonly obs: Observable<any>) {
    super();
    this.obs.pipe(takeUntilDestroyed()).subscribe({
      error: () => (this.error = true),
    });
  }

  override isErrorState(
    control: AbstractControl | null,
    form: FormGroupDirective | NgForm | null,
  ): boolean {
    if (control && this.error) {
      control.setErrors({
        ...control.errors,
        brokenObservable: true,
      });
    }
    return (
      super.isErrorState(control, form) || !!(this.error && control?.invalid)
    );
  }
}
